import { tr } from '../i18n/i18n';

/**
 * Some dropdown/catalog values (privilege names, school types, plan names, ...)
 * are DB rows seeded in English with no translation key of their own — the
 * raw column value is the only thing the API returns. Slugify it and look up
 * "<namespace>.<slug>", falling back to the raw value for anything not yet
 * in the catalog (e.g. a custom row added after this list was written).
 */
export const slugifyForI18n = (value: string): string =>
  value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

export const translateLookupValue = (namespace: string, rawValue: string): string => {
  // An absent value slugifies to '', which would look up "<namespace>." — and
  // tr() drops an empty defaultValue as falsy, so i18next echoes that key back
  // and the UI renders the literal "relationship." Return empty instead and let
  // the caller decide how to render "no value".
  const slug = slugifyForI18n(rawValue ?? '');
  if (!slug) return '';
  return tr(`${namespace}.${slug}`, rawValue);
};
